<template>
  <div>申请标准</div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  created() {
 
  },
  methods: {

  }
};
</script>
